import * as types from './constants';

export const updateClient = (data) => ({
    types: [
        types.UPDATE_CLIENT_REQUEST,
        types.UPDATE_CLIENT_SUCCESS,
        types.UPDATE_CLIENT_FAILURE,
    ],
    promise: api =>
        api({
            url: 'api/v1/clients',
            method: 'POST',
            body: data
        }),
});

export const addClientPhone = (clientId, phone) => ({
    types: [
        types.ADD_CLIENT_PHONE_REQUEST,
        types.ADD_CLIENT_PHONE_SUCCESS,
        types.ADD_CLIENT_PHONE_FAILURE,
    ],
    promise: api =>
        api({
            url: `api/v1/clients/add-phone/${clientId}`,
            method: 'POST',
            body: {phone: phone}
        }),
});

export const deleteClientPhone = (phoneId) => ({
    types: [
        types.DELETE_CLIENT_PHONE_REQUEST,
        types.DELETE_CLIENT_PHONE_SUCCESS,
        types.DELETE_CLIENT_PHONE_FAILURE,
    ],
    promise: api =>
        api({
            url: `api/v1/clients/remove-phone/${phoneId}`,
            method: 'POST',
            body: {},
        }),
});

export const findClients = (phone) => ({
    types: [
        types.FIND_CLIENTS_REQUEST,
        types.FIND_CLIENTS_SUCCESS,
        types.FIND_CLIENTS_FAILURE,
    ],
    promise: api =>
        api({
            url: `api/v1/clients/find?phone=${phone}`,
            method: 'GET',
        }),
});

export const findClientDeliveryDetails = (clientId) => ({
    types: [
        types.FIND_CLIENT_DELIVERY_DETAILS_REQUEST,
        types.FIND_CLIENT_DELIVERY_DETAILS_SUCCESS,
        types.FIND_CLIENT_DELIVERY_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: `api/v1/clients/delivery-details/${clientId}`,
            method: 'GET',
        }),
});
